import { AnimatedGradientText, Container, Typography } from '@mcdougald/ui/src';
import { motion } from 'motion/react';
import dynamic from 'next/dynamic';
import { FaJava, FaNodeJs, FaPython } from 'react-icons/fa';
import { FaGolang } from 'react-icons/fa6';

const DynamicTypewriterEffect = dynamic(
  () => import('@/components/common/animations/typewriter-effect'),
  {
    ssr: false,
  },
);

const animation = {
  negHide: {
    y: -30,
    opacity: 0,
  },
  hide: {
    y: 40,
    opacity: 0,
  },
  yZeroHide: {
    y: 0,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
  },
};

const LandingPageExperienceIcons = [
  {
    icon: <FaNodeJs className={'!text-[#8d8d8d]'} />,
    text: 'Node',
  },
  {
    icon: <FaPython className={'!text-[#8d8d8d]'} />,
    text: 'Python',
  },
  {
    icon: <FaJava className={'!text-[#8d8d8d]'} />,
    text: 'Java',
  },
  {
    icon: <FaGolang className={'!text-[#8d8d8d]'} />,
    text: 'Golang',
  },
];

export const LandingPageHero = (props: { animate?: boolean }) => {
  const { animate = true } = props;

  return (
    <Container
      className="landing-container relative z-10 mx-auto flex h-full items-center px-4 mt-auto"
      maxWidth="4xl"
    >
      {/* </Container> */}
      <div className="landing-hero-box z-10 relative top-[56px] mt-[220px] grid grid-cols-1 gap-8 lg:grid-cols-[auto_400px] lg:justify-between lg:gap-[50px]">
        <div className="landing-hero min-h-[530px] flex relative flex-col rounded-2xl !bg-transparent px-8 py-9">
          {/*<div className="absolute h-[210px] bg-black rounded-full blur-[40px]" />*/}
          <Typography
            className="w-max text-4xl text-white/80 drop-shadow-[0_2.5px_15px_rgba(0,0,0,0.8)] lg:text-9xl"
            variant="hero"
            weight={900}
          >
            <motion.div
              {...(animate && {
                initial: animation.hide,
                animate: animation.show,
              })}
              transition={{ ease: 'easeOut' }}
            >
              Hiya{' '}
              <span aria-labelledby="wave" className="wave text-9xl" role="img">
                👋
              </span>
            </motion.div>
          </Typography>
          <Typography
            className="w-max mt-7 ml-1 text-4xl text-white/95 drop-shadow-[0_2.5px_15px_rgba(0,0,0,0.8)] lg:text-2xl"
            variant="hero"
            weight={400}
          >
            <motion.div
              {...(animate && {
                initial: animation.negHide,
                animate: animation.show,
              })}
              transition={{ ease: 'easeOut' }}
            >
              I'm{' '}
              <AnimatedGradientText className={'font-bold'}>
                Trevor McDougald
              </AnimatedGradientText>
            </motion.div>
          </Typography>
          <Typography
            className="mt-2 ml-1.5 text-white/95 drop-shadow-md text-4xl lg:text-2xl"
            variant="hero"
            weight={400}
          >
            <motion.div
              {...(animate && {
                initial: animation.negHide,
                animate: animation.show,
                transition: {
                  delay: 0.3,
                },
              })}
            >
              A passionate{' '}
              <AnimatedGradientText
                className={'font-bold'}
                colorTo={'#45d4ff'}
                colorFrom={'#0982a4'}
              >
                Full-Stack Dev
              </AnimatedGradientText>
              {/*I enjoy experiments in AWS, UI/UX, DevOps, and Developer-Tooling.*/}
            </motion.div>
          </Typography>

          {/*<motion.div*/}
          {/*  {...(animate && {*/}
          {/*    initial: animation.yZeroHide,*/}
          {/*    animate: animation.show,*/}
          {/*    transition: {*/}
          {/*      delay: 1,*/}
          {/*    },*/}
          {/*  })}*/}
          {/*  className={'flex flex-col mt-12 w-[500px] ml-2 bg-transparent'}*/}
          {/*>*/}
          {/*  <Typography variant={'lg'} className={'text-white/80'}>*/}
          {/*    I enjoy building*/}
          {/*  </Typography>*/}
          {/*  <DynamicTypewriterEffect />*/}
          {/*</motion.div>*/}

          <motion.div
            {...(animate && {
              initial: animation.yZeroHide,
              animate: animation.show,
              transition: {
                delay: 4,
              },
            })}
            transition={{ ease: 'easeOut' }}
            className={
              'flex flex-col bottom-0 min-h-[111px] max-h-[111px] mt-16'
            }
          >
            <Typography
              className="ml-2 text-white/80 drop-shadow-md lg:text-lg"
              variant="lg"
              weight={500}
            >
              {/* Safe, fast and easy. */}6+ years experience delivering with:
            </Typography>
            <div className={'flex w-full gap-2 ml-[8px] mt-[8px]'}>
              {LandingPageExperienceIcons.map((item, index) => {
                return (
                  <motion.div
                    className={
                      'flex gap-2 content-center items-center text-2xl mr-2 w-fit-content py-2 px-4 bg-[#161616] rounded-lg !text-[#8d8d8d]'
                    }
                    key={`${index}-${item.text}`}
                    {...(animate && {
                      initial: animation.yZeroHide,
                      animate: animation.show,
                      transition: {
                        delay: Number(Number(index + 1) * 0.2) + 0.8,
                      },
                    })}
                  >
                    {item.icon}
                    {item.text}
                  </motion.div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </Container>
  );
};
